import React, { useContext, } from 'react'
import { Segment, Divider, Header, Button, Icon, Container } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from '../../../../../App/stores/RootStore'

const RequestReviewValidation = () => {
  const rootStore = useContext(RootStoreContext);
  const { ValidationResult } = rootStore.requestReviewStore;
  const { closeModal } = rootStore.modalStore;

  return (
    <Segment clearing>
      <Header>Validation result</Header>
      <Divider />
      <Container>
            Based on your Answers, your Review Options are: {ValidationResult?.recomendedResults.map(val => (val + " "))}
        
        <Divider hidden />
        
        {ValidationResult?.shouldCalate ? "There was a conflict with the previouse Reviewers and you will also need to escalate/ deescalate the review" : ""}
      </Container>

      <Divider />

      <Button
        className={'rl-btn'}
        onClick={() => closeModal()} >
        Continue
              <Icon name="arrow alternate circle right" />
      </Button>
    </Segment>
  );
}
export default observer(RequestReviewValidation);